import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../ApiConfig/ApiConfig";
import Search from "../../../Assets/Icon search.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faDownload } from "@fortawesome/free-solid-svg-icons";
import CloseIcon from "../../../Assets/close icon.svg";
import Cookies from 'js-cookie';
import * as XLSX from 'xlsx'; // Import the xlsx library

const RegisteredCustomer = () => {
  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageBlockStart, setPageBlockStart] = useState(1); // start of current page block
  const customersPerPage = 10;
  const [selectedCustomer, setSelectedCustomer] = useState(null); // State for selected customer
  const [isPopupOpen, setIsPopupOpen] = useState(false); // State for controlling popup visibility
  const [selectedRole, setSelectedRole] = useState("All"); // State to hold the selected role filter ("All", "User", or "Dealer")
  const token = Cookies.get('admin');
  
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/users/all`,
          {
            headers: {  "Content-Type": "application/json" ,
          "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
         },  
          });
        console.log('Fetched Customers:', response.data); // Log the response data
        if (response.data.length > 0) {
          setCustomers(response.data); // Set all customers directly
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    fetchCustomers();
  }, []);

  // Filter customers based on the search term and selected role
  const filteredCustomers = customers.filter(
    (customer) =>
      (customer.customerId.toLowerCase().includes(searchTerm.toLowerCase()) ||
        customer.name.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (selectedRole === "All" || customer.role === selectedRole)
  );

  const totalPages = Math.ceil(filteredCustomers.length / customersPerPage);
  const firstPagesCount = 5;
  const lastPagesCount = 2;

  // Ensure blockStart stays within valid range
  const maxBlockStart = Math.max(1, totalPages - lastPagesCount - firstPagesCount + 1);
  const blockStart = Math.min(pageBlockStart, maxBlockStart);

  // Pages for the current block
  const middlePages = [];
  for (let i = 0; i < firstPagesCount && blockStart + i <= totalPages - lastPagesCount; i++) {
    middlePages.push(blockStart + i);
  }

  // Last pages
  const lastPageNumbers = [];
  for (let i = totalPages - lastPagesCount + 1; i <= totalPages; i++) {
    if (i > 0) lastPageNumbers.push(i);
  }

  // Slice customers for current page
  const startIdx = (currentPage - 1) * customersPerPage;
  const currentCustomers = filteredCustomers.slice(startIdx, startIdx + customersPerPage);

  const getFirstLetter = name => name.charAt(0).toUpperCase();

  const paginate = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);

    // If clicking last in block, shift so clicked page is first
    if (middlePages.length && pageNumber === middlePages[middlePages.length - 1]) {
      setPageBlockStart(pageNumber);
    }
    // If clicking first in block, shift so clicked page is last of previous block
    else if (middlePages.length && pageNumber === middlePages[0] && pageNumber > 1) {
      const newStart = Math.max(1, pageNumber - (firstPagesCount - 1));
      setPageBlockStart(newStart);
    }
  };


  // Open Popup with selected customer details
  const handleCustomerClick = (customer) => {
    setSelectedCustomer(customer);
    setIsPopupOpen(true); // Open the popup
  };

  // Close the popup
  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedCustomer(null);
  };
  const exportToExcel = () => {
    // Prepare the data for export
    const dataToExport = filteredCustomers.map(customer => ({
      "Customer Name": customer.name,
      "Customer ID": customer.customerId,
      "Phone Number": customer.phone,
      "Email": customer.email,
      "Role": customer.role,
      "Address": customer.address,
    }));

    // Create a new workbook
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(dataToExport);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Customers");

    // Generate the Excel file and trigger download
    XLSX.writeFile(wb, "Customer_Records.xlsx");
  };
  return (
        <div className="p-6 min-h-screen rounded-lg">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-8">
  {/* Title Section */}
  <div>
    <h1 className="text-2xl font-semibold text-gray-800">Customer Records</h1>
    <p className="text-sm text-gray-500 mt-1">
      {filteredCustomers.length} {filteredCustomers.length === 1 ? 'record' : 'records'} found
    </p>
  </div>

  {/* Controls Section */}
  <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
    {/* Role Filter */}
    <div className="flex items-center bg-white p-2 rounded-lg border border-gray-200 shadow-xs">
      <div className="flex space-x-4">
        {['All', 'User', 'Dealer'].map((role) => (
          <label
            key={role}
            className={`flex items-center space-x-2 cursor-pointer ${
              selectedRole === role ? 'text-blue-600' : 'text-gray-600'
            }`}
          >
            <input
              type="radio"
              name="role"
              value={role}
              checked={selectedRole === role}
              onChange={() => setSelectedRole(role)}
              className="hidden"
            />
            <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
              selectedRole === role ? 'border-blue-600' : 'border-gray-300'
            }`}>
              {selectedRole === role && (
                <div className="w-2 h-2 rounded-full bg-blue-600"></div>
              )}
            </div>
            <span className="text-sm">{role}</span>
          </label>
        ))}
      </div>
    </div>

    {/* Export Button */}
    <button
      onClick={exportToExcel}
      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2 shadow-sm min-w-[120px]"
    >
      <FontAwesomeIcon icon={faDownload} className="h-3.5 w-3.5" />
      <span className="text-sm">Export</span>
    </button>

    {/* Search Input */}
    <div className="relative min-w-[200px]">
      <input
        type="text"
        placeholder="Search customers..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-9 pr-3 py-2 rounded-lg w-full border border-gray-300 shadow-xs outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all"
      />
      <img
        src={Search}
        alt="Search"
        className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 opacity-70"
      />
    </div>
  </div>
</div>
    
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-4">
        <p className="font-semibold pl-4 text-[#87909A] sm:block hidden">Customer Name</p>
        <p className="font-semibold pl-2 text-[#87909A] sm:block hidden">Customer ID</p>
        <p className="font-semibold text-[#87909A] sm:block hidden">Phone Number</p>
        <p className="font-semibold text-[#87909A] sm:block hidden">Role</p>
      </div>
    
      <div className="container mx-auto">
        {currentCustomers.length > 0 ? (
          currentCustomers.map((customer, index) => (
            <div
              key={customer.customerId}
              onClick={() => handleCustomerClick(customer)} // Open the popup when clicked
              className={`bg-white shadow-md rounded-lg p-4 mb-4 transition-all duration-300 ease-in-out transform ${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                } group hover:bg-gray-100 hover:scale-[1.02] hover:shadow-lg hover:cursor-pointer`}
            >
              <div className="space-y-4">
                {/* Vertical Data */}
                <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 items-center">
                  {/* Circle with the first letter of the customer's name */}
                  <div className="flex items-center space-x-3">
                    <div className="w-7 h-7 bg-[#1C50A3] text-white rounded-full flex items-center justify-center font-bold group-hover:bg-blue-600">
                      {getFirstLetter(customer.name)}
                    </div>
                    <p className="text-[#292D32] font-semibold group-hover:text-blue-600">
                      {customer.name}
                    </p>
                  </div>
                  <p className="text-[#292D32] font-semibold group-hover:text-blue-600">
                    {customer.customerId}
                  </p>
                  <p className="text-[#292D32] font-semibold group-hover:text-blue-600">
                    {customer.phone}
                  </p>
                  <p className="text-[#292D32] font-semibold group-hover:text-blue-600">
                    {customer.role}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="py-3 px-5 text-center text-gray-600">
            No customer found.
          </div>
        )}
      </div>
      {/* Pagination Controls */}
      <div className="flex justify-center mt-6 items-center space-x-1">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 text-gray-600 rounded-l-lg disabled:opacity-50 text-sm flex items-center font-semibold"
        >
          <FontAwesomeIcon icon={faChevronLeft} className="mr-2" /> Previous
        </button>

        {/* Render pages */}
        {totalPages <= firstPagesCount + lastPagesCount ? (
          // If few pages, show all
          Array.from({ length: totalPages }, (_, idx) => idx + 1).map(num => (
            <button
              key={num}
              onClick={() => paginate(num)}
              className={`px-3 py-1 mx-1 rounded-lg text-sm font-semibold ${
                currentPage === num
                  ? "bg-[#1C50A3] text-white"
                  : "bg-white text-gray-600"
              }`}
            >
              {num}
            </button>
          ))
        ) : (
          <>
            {middlePages.map(num => (
              <button
                key={num}
                onClick={() => paginate(num)}
                className={`px-3 py-1 mx-1 rounded-lg text-sm font-semibold ${
                  currentPage === num
                    ? "bg-[#1C50A3] text-white"
                    : "bg-white text-gray-600"
                }`}
              >
                {num}
              </button>
            ))}
            <span className="px-3 py-1 text-gray-600 font-semibold">...</span>
            {lastPageNumbers.map(num => (
              <button
                key={num}
                onClick={() => paginate(num)}
                className={`px-3 py-1 mx-1 rounded-lg text-sm font-semibold ${
                  currentPage === num
                    ? "bg-[#1C50A3] text-white"
                    : "bg-white text-gray-600"
                }`}
              >
                {num}
              </button>
            ))}
          </>
        )}

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 text-gray-600 rounded-r-lg disabled:opacity-50 text-sm flex items-center font-semibold"
        >
          Next <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
        </button>
      </div>

      {/* Popup Modal */}
      {isPopupOpen && selectedCustomer && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-1/3 relative">
            <button
              onClick={closePopup}
              className="absolute top-1 right-1 px-4 py-2  text-white rounded-lg flex items-center"
            >
              <img
                src={CloseIcon} // Replace this with the actual image path
                alt="Close Icon"
                className="w-16 h-16 "
              />
            
            </button>
            <h2 className="text-2xl font-semibold mb-4">Customer Details</h2>
            <div className="flex justify-between border border-dashed p-2 mb-2">
              <p><strong>Name:</strong></p>
              <p>{selectedCustomer.name}</p>
            </div>
            <div className="flex justify-between border border-dashed p-2 mb-2">
              <p><strong>Customer ID:</strong></p>
              <p>{selectedCustomer.customerId}</p>
            </div>
            <div className="flex justify-between border border-dashed p-2 mb-2">
              <p><strong>Phone Number:</strong></p>
              <p>{selectedCustomer.phone}</p>
            </div>
            <div className="flex justify-between border border-dashed p-2 mb-2">
              <p><strong>Email:</strong></p>
              <p>{selectedCustomer.email}</p>
            </div>
            <div className="flex justify-between border border-dashed p-2 mb-2">
              <p><strong>Role:</strong></p>
              <p>{selectedCustomer.role || "No role available"}</p>
            </div>
            <div className="flex justify-between border border-dashed p-2 mb-2">
              <p><strong>Address:</strong></p>
              <p>{selectedCustomer.address}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisteredCustomer;
